import { render, staticRenderFns } from "./TravelExpensesSection.vue?vue&type=template&id=73012671&scoped=true&"
import script from "./TravelExpensesSection.vue?vue&type=script&lang=js&"
export * from "./TravelExpensesSection.vue?vue&type=script&lang=js&"
import style0 from "./TravelExpensesSection.vue?vue&type=style&index=0&id=73012671&prod&lang=css&"
import style1 from "./TravelExpensesSection.vue?vue&type=style&index=1&id=73012671&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73012671",
  null
  
)

export default component.exports